<template>
  <v-container id="calculator-wrapper">
    <div class="hero-image hero-image3">
      <div class="hero-text">
        <h1 class="mb-4 heading">
            Calculate Monthly Earnings
          </h1>
          <h4 class="subheading">
            Dentist Associate Profit Sharing
          </h4>
      </div>
    </div>
    <v-container class="calculator-container">
      <v-row>
        <v-col class="input-column">
          <v-container>
            <v-row>
              <v-col class="section-header text-center header-text">INPUTS</v-col>
            </v-row>
            <v-row class="column-labels">
              <v-col></v-col>
              <v-col md="2" class="col-input">Scenario 1</v-col>
              <v-col md="2" class="col-input">Scenario 2</v-col>
            </v-row>
          </v-container>
          <v-row align="center" justify="center" class="calculator-row"><!-- Patient Net Promoter Score (NPS) -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header "
                    v-bind="attrs"
                    v-on="on"
                  > Patient Net Promoter Score (NPS) </span>
                </template>
                <span v-html="this.tipPatientLoyaltyScore"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtPatientSatisfactionScoreCurrent"
                  placeholder=""
                  type="number"
                  min="0"
                  max="100"
                  @input="updateFields"
                  filled
                  rounded
                  dense
                  hide-details
                  hide-spin-buttons
                  reverse
                  style="height: 30px; border-radius:10px; font-size: 1rem;"
                  class="text-blue number-input loyalty-select"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtPatientSatisfactionScoreCalculated"
                  placeholder=""
                  type="number"
                  min="0"
                  max="100"
                  @input="updateFields"
                  filled
                  rounded
                  dense
                  hide-details
                  hide-spin-buttons
                  reverse
                  style="height: 30px; border-radius:10px"
                  class="text-blue number-input loyalty-select"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!--Minimum Profit Share-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Minimum Profit Share</span>
                </template>
                <span  v-html="this.tipMinimumProfitShare"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="txtMinimumProfitShareCurrent"
                  placeholder=""
                  type="number"
                  @input="updateFields"
                  filled
                  rounded
                  style="height: 30px; border-radius:10px;"
                  reverse
                  class="text-blue number-input percent-input"
                  hide-spin-buttons
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="txtMinimumProfitShareCalculated"
                  placeholder=""
                  type="number"
                  @input="updateFields"
                  filled
                  rounded
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input percent-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!--Maximum Profit Share-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Maximum Profit Share</span>
                </template>
                <span v-html="this.tipMaximumProfitShare"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="txtMaximumProfitShareCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input percent-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="txtMaximumProfitShareCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input percent-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!--Average Production/Deposit-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Average Production/Deposit</span>
                </template>
                <span v-html="this.tipAverageProduction"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtAverageProductionCurrent"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtAverageProductionCalculated"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Daily Guarantee -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Daily Guarantee</span>
                </template>
                <span v-html="this.tipDailyGuarantee"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtDailyGuaranteCurrent"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtDailyGuaranteCalculated"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Days Worked Per Month -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Days Worked Per Month</span>
                </template>
                <span v-html="this.tipDaysWorkedPerMonth"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtDaysWorkedPerMonthCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtDaysWorkedPerMonthCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Days Open Per Month -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Days Open Per Month</span>
                </template>
                <span v-html="this.tipDaysOpenPerMonth"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtDaysOpenPerMonthCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtDaysOpenPerMonthCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col  class="blueBackground results-column">
          <v-container>
            <v-row>
              <v-col class="section-header text-center header-text">PROJECTED EARNINGS</v-col>
            </v-row>
            <v-row class="column-labels">
              <v-col></v-col>
              <v-col md="2" class="col-input">Scenario 1</v-col>
              <v-col md="2" class="col-input">Scenario 2</v-col>
            </v-row>
          </v-container>
          <v-row align="center" justify="center" class="calculator-row"> <!--Average Production/Deposit -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Average Production/Deposit</span>
                </template>
                <span v-html="this.tipAverageProduction"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtAverageProductionCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtAverageProductionCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!-- Controllable Expenses -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Controllable Expenses</span>
                </template>
                <span v-html="this.tipControllableExpenses"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultControllableExpensesCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultControllableExpensesCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="darkBlueBackground"><!-- Gross Profit -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  > Gross Profit</span>
                </template>
                <span v-html="this.tipGrossProfit"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultGrossProfitCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultGrossProfitCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!-- Profit Share % (Calculated) -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Profit Share % (Calculated)</span>
                </template>
                <span v-html="this.tipProfitSharing"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="resultProfitSharingCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input percent-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="resultProfitSharingCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input percent-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!-- Eligible Associate Profit Sharing -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class=""
                    v-bind="attrs"
                    v-on="on"
                  > Eligible Associate Profit Sharing</span>
                </template>
                <span v-html="this.tipEligibleAssociateProfitShare"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultEligibleAssociateProfitSharingCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultEligibleAssociateProfitSharingCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!--Minimum Guaranteed Monthy Earnings -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  >Minimum Guaranteed Monthly Earnings</span>
                </template>
                <span v-html="this.tipMinimumGuaranteedMonthlyEarnings"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultMinimumGuaranteedMonthlyEarningsCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultMinimumGuaranteedMonthlyEarningsCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class=""> <!-- Total Profit Sharing in $ -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  >Total Profit Sharing in $</span>
                </template>
                <span v-html="this.tipTotalProfitSharing"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultTotalProfitSharingCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultTotalProfitSharingCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class=" darkBlueBackground"> <!-- Associate Total Monthly Earnings -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  >Associate Total Monthly Earnings</span>
                </template>
                <span v-html="this.tipAssociateTotalMonthlyEarnings"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateTotalMonthlyEarningsCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateTotalMonthlyEarningsCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="instructions-row">
            <v-col class= "instructions-right disclaimer">Controllable expenses may vary month to month. Example above reflective of 25% of Average Production/Deposit.</v-col>
          </v-row>
          <!-- <v-container class="footer-container">
            <v-row align="center" justify="center" class="calculator-row">
              <button v-on:click="reset" class="footer-button"><img src="../assets/img/button-startover.svg" /></button>
              <router-link to="/"><button v-on:click="reset" class="footer-button"><img src="../assets/img/button-home.svg" /></button></router-link>
              <button v-on:click="getScreenShot" class="footer-button"><img src="../assets/img/button-share.svg" /></button>
              <img id="screenshot">
            </v-row>
          </v-container> -->
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<style scoped>
.loyalty-select >>> .v-select__selection {
  width: 100%;
  max-width: 100%;
  justify-content: flex-end;
  text-align: right;
  color: #004BB9 !important;
  font-size: 1rem;
  font-weight: normal;
}
.number-input >>> input[type="number"] {
  -moz-appearance: textfield;
}
.number-input >>> input::-webkit-outer-spin-button,
.number-input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
<script>
  export default {
    name: 'Calculator',
    methods: {
      updateFields (){
        this.numAverageProductionCurrent = this.txtAverageProductionCurrent.toString().replaceAll(',', '');
        this.numAverageProductionCalculated = this.txtAverageProductionCalculated.toString().replaceAll(',', '');
        this.numDailyGuaranteCurrent = this.txtDailyGuaranteCurrent.toString().replaceAll(',', '');
        this.numDailyGuaranteCalculated = this.txtDailyGuaranteCalculated.toString().replaceAll(',', '');

        /*Controllable Expenses*/
        this.resultControllableExpensesCurrent = (this.numAverageProductionCurrent * .25) + 1000;
        this.resultControllableExpensesCalculated = (this.numAverageProductionCalculated * .25) + 1000 ;
        /* Gross Profit */
        this.resultGrossProfitCurrent = this.numAverageProductionCurrent - this.resultControllableExpensesCurrent;
        this.resultGrossProfitCalculated = this.numAverageProductionCalculated - this.resultControllableExpensesCalculated;
        /* Profit Share % */
        this.resultProfitSharingCurrent = this.getProfitSharing(this.txtPatientSatisfactionScoreCurrent, this.txtMinimumProfitShareCurrent, this.txtMaximumProfitShareCurrent);
        this.resultProfitSharingCalculated = this.getProfitSharing(this.txtPatientSatisfactionScoreCalculated, this.txtMinimumProfitShareCalculated, this.txtMaximumProfitShareCalculated);
        /* Eligible Associate Profit Sharing */
        this.resultEligibleAssociateProfitSharingCurrent = (this.resultGrossProfitCurrent * this.resultProfitSharingCurrent/100) * (this.txtDaysWorkedPerMonthCurrent/this.txtDaysOpenPerMonthCurrent);
        this.resultEligibleAssociateProfitSharingCalculated = (this.resultGrossProfitCalculated * this.resultProfitSharingCalculated/100) * (this.txtDaysWorkedPerMonthCalculated/this.txtDaysOpenPerMonthCalculated);
        /*Hygiene Earned Monthly Incentive*/
        this.resultMinimumGuaranteedMonthlyEarningsCurrent = this.numDailyGuaranteCurrent * this.txtDaysWorkedPerMonthCurrent;
        this.resultMinimumGuaranteedMonthlyEarningsCalculated = this.numDailyGuaranteCalculated * this.txtDaysWorkedPerMonthCalculated;
        /*Profit Share in $*/
        this.resultTotalProfitSharingCurrent = (this.resultEligibleAssociateProfitSharingCurrent - this.resultMinimumGuaranteedMonthlyEarningsCurrent) > 0 ? (this.resultEligibleAssociateProfitSharingCurrent - this.resultMinimumGuaranteedMonthlyEarningsCurrent) : 0 ;
        this.resultTotalProfitSharingCalculated = (this.resultEligibleAssociateProfitSharingCalculated - this.resultMinimumGuaranteedMonthlyEarningsCalculated) > 0 ? (this.resultEligibleAssociateProfitSharingCalculated - this.resultMinimumGuaranteedMonthlyEarningsCalculated) : 0 ;
        /*AssociateTotal Monthly Earnings*/
        this.resultAssociateTotalMonthlyEarningsCurrent = Math.max(this.resultEligibleAssociateProfitSharingCurrent, this.resultMinimumGuaranteedMonthlyEarningsCurrent);
        this.resultAssociateTotalMonthlyEarningsCalculated = Math.max(this.resultEligibleAssociateProfitSharingCalculated, this.resultMinimumGuaranteedMonthlyEarningsCalculated);

        /*Format numbers for display*/
        this.txtAverageProductionCurrentFormatted = this.roundAndFormat(this.numAverageProductionCurrent);
        this.txtAverageProductionCalculatedFormatted = this.roundAndFormat(this.numAverageProductionCalculated);
        this.resultControllableExpensesCurrentFormatted =  this.roundAndFormat(this.resultControllableExpensesCurrent);
        this.resultControllableExpensesCalculatedFormatted =  this.roundAndFormat(this.resultControllableExpensesCalculated);
        this.resultGrossProfitCurrentFormatted = this.roundAndFormat(this.resultGrossProfitCurrent);
        this.resultGrossProfitCalculatedFormatted = this.roundAndFormat(this.resultGrossProfitCalculated);
        this.resultProfitSharingCurrentFormatted = this.roundAndFormatProfitSharing(this.resultProfitSharingCurrent);
        this.resultProfitSharingCalculatedFormatted = this.roundAndFormatProfitSharing(this.resultProfitSharingCalculated);
        this.resultEligibleAssociateProfitSharingCurrentFormatted = this.roundAndFormat(this.resultEligibleAssociateProfitSharingCurrent);
        this.resultEligibleAssociateProfitSharingCalculatedFormatted = this.roundAndFormat(this.resultEligibleAssociateProfitSharingCalculated);
        this.resultMinimumGuaranteedMonthlyEarningsCurrentFormatted = this.roundAndFormat(this.resultMinimumGuaranteedMonthlyEarningsCurrent);
        this.resultMinimumGuaranteedMonthlyEarningsCalculatedFormatted = this.roundAndFormat(this.resultMinimumGuaranteedMonthlyEarningsCalculated);
        this.resultAssociateTotalMonthlyEarningsCurrentFormatted = this.roundAndFormat(this.resultAssociateTotalMonthlyEarningsCurrent);
        this.resultAssociateTotalMonthlyEarningsCalculatedFormatted = this.roundAndFormat(this.resultAssociateTotalMonthlyEarningsCalculated);
        this.resultTotalProfitSharingCurrentFormatted = this.roundAndFormat(this.resultTotalProfitSharingCurrent);
        this.resultTotalProfitSharingCalculatedFormatted = this.roundAndFormat(this.resultTotalProfitSharingCalculated);

      },
      updateState(state) {
        var selectedState = this.states.filter(function(ele){
          return (ele.name == state)
        });
        if(selectedState.length){this.planType = selectedState[0].planType}
        this.updateFields();
      },
      roundAndFormat(number) {
        var result = Math.round(number);
        result = result.toLocaleString();
        return result;
      },
      roundAndFormatProfitSharing(number) {
        var result = number.toLocaleString();
        return result;
      },
      currencyFormat(number){
        var currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
        return currency;
      },
      getProfitSharing(nps, minimumProfitShare, maximumProfitShare) {
          var profitshare = 0;
          var increment = (maximumProfitShare - minimumProfitShare)/4;
          nps = Number(nps);
          if (nps <= 50) {
            profitshare = minimumProfitShare;
          }
          else if(nps < 62) {
            profitshare = Number(minimumProfitShare) + Number(increment);
          }
          else if(nps < 75) {
            profitshare = Number(minimumProfitShare) + Number(increment*2);
          }
          else if(nps < 80) {
            profitshare = Number(minimumProfitShare) + Number(increment*3);
          }
          else {
            profitshare = Number(minimumProfitShare) + Number(increment*4);
          }
          return profitshare;
      },
      reset(){
        this.updateFields();
      },


    },

    data: () => ({
      txtPatientSatisfactionScoreCurrent: 60,
      txtPatientSatisfactionScoreCalculated: 60,
      txtMinimumProfitShareCurrent: 8,
      txtMinimumProfitShareCalculated: 8,
      txtMaximumProfitShareCurrent:10,
      txtMaximumProfitShareCalculated: 10,
      txtAverageProductionCurrent: "250,000",
      txtAverageProductionCalculated: "250,000",
      txtDailyGuaranteCurrent: "800",
      txtDailyGuaranteCalculated: "800",
      txtDaysWorkedPerMonthCurrent: 21,
      txtDaysWorkedPerMonthCalculated: 21,
      txtDaysOpenPerMonthCurrent: 22,
      txtDaysOpenPerMonthCalculated: 22,

//: "<p><strong></strong></p>",
      tipPatientLoyaltyScore: "<p><strong> Patient Satisfaction Score (NPS) </strong></p>%Promoters -%Detractors = Net Promoter Score.",
      tipMinimumProfitShare: "<p><strong>Minimum Profit Share</strong></p>Minimum potential profit share % based on profit share plan",
      tipMaximumProfitShare: "<p><strong>Maximum Profit Share</strong></p>Maximum potential profit share % based on profit share plan",
      tipAverageProduction: "<p><strong>Average Production/Deposit</strong></p>Average of current month's production and deposits",
      tipDailyGuarantee:  "<p><strong>Daily Guarantee</strong></p>Advance in pay that provides you with consistent pay checks so you can manage day-to-day finances",
      tipDaysWorkedPerMonth: "<p><strong>Days worked per month</strong></p>Assumed days worked per month",
      tipDaysOpenPerMonth: "<p><strong>Days open per month</strong></p>Assumed days open per month",

      tipControllableExpenses:"<p><strong>Controllable Expenses</strong></p>Controllable expenses include lab supplies, hygiene supplies, dental supplies, processing fees, field management fee, lab tech salaries, central lab allocation, dental assistant wages, hygienist wages, specialty wages, financing service charges. Currently assumed at 35% of production/deposit; includes $1,000/monthly management fee.",
      tipGrossProfit: "<p><strong>Gross Profit</strong></p>Calculation = average production/deposit, less direct expenses",
      tipProfitSharing: "<p><strong>Profit Share Percent</strong></p>Profit share is dependent on patient satisfaction score",
      tipEligibleAssociateProfitShare: "<p><strong>Eligible Associate Profit Sharing</strong></p>Gross Profit × Actual Profit Share % × (Days Worked ÷ Office Days Open).",
      tipMinimumGuaranteedMonthlyEarnings: "<p><strong>Minimum Guaranteed Monthly Earnings</strong></p>Advance in pay that provides you with consistent pay checks so you can manage monthly finances",
      tipTotalProfitSharing: "<p><strong>Total Profit Sharing</strong></p>Calculation = Associate Total Monthly Earnings - Minimum Guaranteed Monthly Earnings",
      tipAssociateTotalMonthlyEarnings: "<p><strong>Associate Total Monthly Earnings</strong></p>Calculation = Maximum of gross profit x actual profit share % or Minimum Guaranteed Monthly Earnings",


        minProfitShare: 14,
        maxProfitShare: 21,
        rangeProfitShare: [14, 21],

    }),
    watch: {
      txtAverageProductionCurrent: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtAverageProductionCurrent = result);
      },
      txtAverageProductionCalculated: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtAverageProductionCalculated = result);
      },
      txtDailyGuaranteCurrent: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtDailyGuaranteCurrent = result);
      },
      txtDailyGuaranteCalculated: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtDailyGuaranteCalculated = result);
      },
    },
    created(){
      this.updateFields();
    },
  }
</script>
